import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import * as Styled from './styled';

function ErrorWithCountdown({ refreshInterval, errorMessageId }) {
  const intervalSeconds = refreshInterval / 1000;
  const [theCount, setTheCount] = useState(intervalSeconds);

  useEffect(() => {
    const currCount = theCount;
    const countdown = setInterval(() => {
      if (theCount > 0) {
        setTheCount(currCount - 1);
      } else if (theCount === 0) {
        setTheCount(intervalSeconds);
      }
    }, 1000);
    return () => {
      clearInterval(countdown);
    };
  }, [intervalSeconds, theCount]);

  return (
    <Styled.PromptWrapper>
      <Styled.InfoIcon />
      <Styled.Description>
        <FormattedMessage id={errorMessageId} />
      </Styled.Description>
      <Styled.Countdown>
        <Styled.CircleProgressbar duration={intervalSeconds} />
        <FormattedMessage
          id="detailview.vehicletryingin"
          values={{ count: theCount }}
        />
      </Styled.Countdown>
    </Styled.PromptWrapper>
  );
}
ErrorWithCountdown.propTypes = {
  /** Uses the interval set in parent component and counts down */
  refreshInterval: PropTypes.number,
  /** The message to display */
  errorMessageId: PropTypes.string,
};

ErrorWithCountdown.defaultProps = {
  refreshInterval: 5000,
  errorMessageId: 'detailview.vehiclenotfound',
};
export default ErrorWithCountdown;
